import { usePriceGroupTab } from 'core/contexts/priceGroupTab';
import { PaginationControlled } from '@utriper/core-ui';
import { Box, Fade, Grid2 } from '@mui/material';
import PriceGroupCard from '../PriceGroupCard';

const PriceGroupCards = () => {
    const { handlePagePriceGroup, loading, priceGroups, totalPriceGroups, MAX_PAGE, pagePg } = usePriceGroupTab();

    return (
        <Fade in={!loading} timeout={300}>
            <Box component="section" display="flex" flexDirection="column" mt="16px" gap="16px">
                <Grid2 container size={12} spacing={2}>
                    {priceGroups.map(({ id, name, status, type, experienceId }) => (
                        <PriceGroupCard key={id} id={id} name={name} status={status} type={type} experienceId={experienceId} />
                    ))}
                </Grid2>
                {totalPriceGroups / MAX_PAGE > 1 && <PaginationControlled count={Math.ceil(totalPriceGroups / MAX_PAGE)} page={pagePg} onChange={handlePagePriceGroup} totalItems={totalPriceGroups} itemsPerPage={MAX_PAGE} />}
            </Box>
        </Fade>
    );
};

export default PriceGroupCards;
